module.exports = __webpack_public_path__ + "static/media/complaint_policy.62036bb3.pdf";